import { createFileRoute } from "@tanstack/react-router";
import { ServerDetail } from "../-servers/ServerDetail";

export const Route = createFileRoute("/admin/servers/$node")({
  staticData: { title: "Server" },
  component: ServerDetail,
});
